const mySideBar = {
    
    'mySideBar.myauthenticator': '我的验证器',
    'mySideBar.myapikey': '我的API密钥', 
    'mySideBar.accountSet': '账户设置', 
    'mySideBar.tip1': '此页面提供了您的HPB帐户的概述', 
};

export default mySideBar;
